import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService } from 'src/services/authorization.service';
import { IdentityService } from 'src/services/identity.service';
import { MessageService } from 'primeng/api';
import { ClaimsEnum } from 'src/models/claims.enum';

@Injectable({
  providedIn: 'root'
})
export class LegalAdGuard  {

  constructor(private authService: AuthorizationService, private router: Router, 
              private identityService: IdentityService, private messageService: MessageService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.authenticated()) {
      var role = this.authService.getRoles();
      if (role && role[0] === ClaimsEnum.LegalAdApprove) {
        // Is the current path equivalent to /form/{id}/ for the Approval User?
        const formPathMatches = state.url.match(/\/form\/([0-9]+)(?=[^\/]*$)/i);
        if (!formPathMatches) {
          this.returnUnauthorized();
        }
      }
      return true;
    } 
    else {
      this.returnUnauthorized();
    }
  }

  private returnUnauthorized() {
    this.messageService.add({severity: 'error', summary: 'Error', detail: "Sorry, you don't have permission to view this page."});
    this.router.navigate(['/']);
    return false;
  }
}
